import { LoginBoxStyled, LoginStyled } from "./styled/LoginStyled.js";
import LoginWrapper from "./LoginWrapper.jsx";
import ForgotPasswordContent from "./ForgotPasswordContent";
import { ForgotPasswordWrapperStyled } from "./styled/ForgotPasswordStyled";

function ForgotPassword() {
    return <LoginWrapper hideAuthButton>
        <LoginStyled>
            <LoginBoxStyled>
                <ForgotPasswordWrapperStyled>
                    <ForgotPasswordContent/>
                </ForgotPasswordWrapperStyled>
            </LoginBoxStyled>
        </LoginStyled>
    </LoginWrapper>
}

export default ForgotPassword;
